/**
 * Created by Jonas Wålekvist on 2017-12-11.
 */

/**
 * Modified by Pradeep Kumar on 01/18/2019.
 */

import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {
    IStillImageBgIntroViewConfig,
    StillImageBgIntroView
} from "@nolimitcity/slot-game/bin/game/intro/StillImageBgIntroView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {CreepyCarnivalTwoGameAssets} from "../CreepyCarnivalTwoGameAssets";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";

export class CreepyCarnivalTwoIntroView extends StillImageBgIntroView {

    private _text: PIXI.Text;
    private _freeWinSpinsTitle: PIXI.Text;
    private _freeWinSpinsInfo1: PIXI.Text;
    private _freeWinSpinsInfo2: PIXI.Text;
    private _starSpinTitle: PIXI.Text;
    private _starSpinInfo: PIXI.Text;
    private _freeSpinsTitle: PIXI.Text;
    private _freeSpinsInfo1: PIXI.Text;
    private _freeSpinsInfo2: PIXI.Text;
    private _freeSpinsInfo3: PIXI.Text;
    private _freeSpinsInfo4: PIXI.Text;
    private _logo: PIXI.Sprite;
    private _gfxContainer: PIXI.Container;
    private _featuresHeadings: PIXI.Text[];
    private _features: PIXI.Text[];
    private _leftContainer: PIXI.Container;
    private _rightContainer: PIXI.Container;


    constructor(config: IStillImageBgIntroViewConfig) {
        super(config);
    }

    protected createGameGraphics(): PIXI.DisplayObject {
        this._gfxContainer = new PIXI.Container();
        this._leftContainer = new PIXI.Container();
        this._rightContainer = new PIXI.Container();
        this._text = new PIXI.Text("Some text on the intro?", {fill: 0xffffff, fontSize: 80});
        this._features = [];
        this._featuresHeadings = [];
        this._text.anchor.set(0.5, 0);

        return this._gfxContainer;
    }

    protected onResizeGameGraphics(resizeData: IResizeData): void {
        if (resizeData.orientation === Orientation.PORTRAIT) {
            this._text.scale.set(2);
            this._text.position.set(0, 400);
            this._gfxContainer.position.set(GameConfig.instance.GAME_WIDTH / 2, this._screenHeight * 0.3);
            this._featuresHeadings.forEach((feature: PIXI.Text, index: number) => {
                feature.visible = false;
            });
            this._features.forEach((feature: PIXI.Text, index: number) => {
                feature.visible = false;
            });

            this._leftContainer.visible = false;
            this._rightContainer.visible = false;
        } else {
            this._text.scale.set(1);
            this._text.position.set(0, 280);
            this._gfxContainer.position.set(GameConfig.instance.GAME_WIDTH / 2, this._screenHeight * 0.1);
            this._featuresHeadings.forEach((feature: PIXI.Text, index: number) => {
                feature.visible = true;
            });
            this._features.forEach((feature: PIXI.Text, index: number) => {
                feature.visible = true;
            });

            this._leftContainer.visible = true;
            this._rightContainer.visible = true;
        }
        if (UserAgent.isMobile) { //only for mobile and landscape
            this._text.scale.set(1);
            this._text.position.set(0, 280);
            this._gfxContainer.position.set(this._screenWidth / 2, 0);
            const offsetXHeading: number = MathHelper.roundToDecimals(Math.min(this._leftContainer.width / 5, Math.max(0, (this._screenWidth - 5 * this._leftContainer.width) / 2)), 2);
            this._leftContainer.position.set(-0.99 * offsetXHeading, this._screenHeight * 0.3);
            this._rightContainer.position.set(2 * offsetXHeading - offsetXHeading, this._screenHeight * 0.3);
        }
    }

    protected onResizeBackground(resizeData: IResizeData): void {
        super.onResizeBackground(resizeData);

        if (resizeData.orientation !== Orientation.PORTRAIT) {
            return;
        }
    }

    protected setButtonPosition(): void {
        this._button.position.set(this._screenWidth * 0.5, this._screenHeight * 0.90);
    }

    private createGameText(container: PIXI.Container): void {
        const headingStyle: object = {
            fill: 0xFFFF33,
            fontSize: 24,
            fontFamily: "Open Sans",
            fontStyle: "italic",
            fontWeight: "800",
            lineHeight: 30
        }, descStyle: object = {
            fill: 0xffffff,
            fontSize: 16,
            fontFamily: "Open Sans",
            fontWeight: "200",
            wordWrap: true,
            wordWrapWidth: 200
        };
        this._freeWinSpinsTitle = new PIXI.Text(Translation.translate("FREE WINSPINS"), headingStyle);
        this._freeWinSpinsTitle.name = "_freeWinSpinsTitle";
        this._freeWinSpinsTitle.anchor.set(0, 0);
        this._freeWinSpinsTitle.x = -550;
        this._freeWinSpinsTitle.y = 100;
        this._featuresHeadings.push(this._freeWinSpinsTitle);
        container.addChild(this._freeWinSpinsTitle);
        this._leftContainer.addChild(this._freeWinSpinsTitle);

        this._freeWinSpinsInfo1 = new PIXI.Text(Translation.translate("All winning symbols are re-spun for X2 and X3 multipliers!"), descStyle);
        this._freeWinSpinsInfo1.name = "_freeWinSpinsInfo1";
        this._freeWinSpinsInfo1.anchor.set(0, 0);
        this._freeWinSpinsInfo1.x = -550;
        this._freeWinSpinsInfo1.y = 160;
        this._features.push(this._freeWinSpinsInfo1);
        container.addChild(this._freeWinSpinsInfo1);
        this._leftContainer.addChild(this._freeWinSpinsInfo1);

        this._freeWinSpinsInfo2 = new PIXI.Text(Translation.translate("All wild symbols are sticky during re-spins!"), descStyle);
        this._freeWinSpinsInfo2.name = "_freeWinSpinsInfo2";
        this._freeWinSpinsInfo2.anchor.set(0, 0);
        this._freeWinSpinsInfo2.x = -550;
        this._freeWinSpinsInfo2.y = this._freeWinSpinsInfo1.y + this._freeWinSpinsInfo1.height;
        this._features.push(this._freeWinSpinsInfo2);
        container.addChild(this._freeWinSpinsInfo2);
        this._leftContainer.addChild(this._freeWinSpinsInfo2);

        this._starSpinTitle = new PIXI.Text(Translation.translate("STAR SPIN"), headingStyle);
        this._starSpinTitle.name = "_starSpinTitle";
        this._starSpinTitle.anchor.set(0, 0);
        this._starSpinTitle.x = -550;
        this._starSpinTitle.y = 325;
        this._featuresHeadings.push(this._starSpinTitle);
        container.addChild(this._starSpinTitle);
        this._leftContainer.addChild(this._starSpinTitle);

        this._starSpinInfo = new PIXI.Text(Translation.translate("Collect 13 high value symbols for a FREE Star Spin with 2 extra wilds!"), descStyle);
        this._starSpinInfo.name = "_starSpinInfo";
        this._starSpinInfo.anchor.set(0, 0);
        this._starSpinInfo.x = -550;
        this._starSpinInfo.y = 355;
        this._features.push(this._starSpinInfo);
        container.addChild(this._starSpinInfo);
        this._leftContainer.addChild(this._starSpinInfo);

        this._freeSpinsTitle = new PIXI.Text(Translation.translate("FREESPINS"), headingStyle);
        this._freeSpinsTitle.name = "_freeSpinsTitle";
        this._freeSpinsTitle.anchor.set(0, 0);
        this._freeSpinsTitle.x = 340;
        this._freeSpinsTitle.y = 100;
        this._featuresHeadings.push(this._freeSpinsTitle);
        container.addChild(this._freeSpinsTitle);
        this._rightContainer.addChild(this._freeSpinsTitle);

        this._freeSpinsInfo1 = new PIXI.Text(Translation.translate("Trigger Freespins with 3 or more Scatters."), descStyle);
        this._freeSpinsInfo1.name = "_freeSpinsInfo1";
        this._freeSpinsInfo1.anchor.set(0, 0);
        this._freeSpinsInfo1.x = 340;
        this._freeSpinsInfo1.y = 130;
        this._features.push(this._freeSpinsInfo1);
        container.addChild(this._freeSpinsInfo1);
        this._rightContainer.addChild(this._freeSpinsInfo1);

        this._freeSpinsInfo2 = new PIXI.Text(Translation.translate("20 extra win lines are activated during Freespins!"), descStyle);
        this._freeSpinsInfo2.name = "_freeSpinsInfo2";
        this._freeSpinsInfo2.anchor.set(0, 0);
        this._freeSpinsInfo2.x = 340;
        this._freeSpinsInfo2.y = this._freeSpinsInfo1.y + this._freeSpinsInfo1.height + 25;
        this._features.push(this._freeSpinsInfo2);
        container.addChild(this._freeSpinsInfo2);
        this._rightContainer.addChild(this._freeSpinsInfo2);


        this._freeSpinsInfo3 = new PIXI.Text(Translation.translate("And multiplier is set to X5!"), descStyle);
        this._freeSpinsInfo3.name = "_freeSpinsInfo3";
        this._freeSpinsInfo3.anchor.set(0, 0);
        this._freeSpinsInfo3.x = 340;
        this._freeSpinsInfo3.y = this._freeSpinsInfo2.y + this._freeSpinsInfo2.height + 25;
        this._features.push(this._freeSpinsInfo3);
        container.addChild(this._freeSpinsInfo3);
        this._rightContainer.addChild(this._freeSpinsInfo3);

        this._freeSpinsInfo4 = new PIXI.Text(Translation.translate("Crazy stuff!"), descStyle);
        this._freeSpinsInfo4.name = "_freeSpinsInfo4";
        this._freeSpinsInfo4.anchor.set(0, 0);
        this._freeSpinsInfo4.x = 340;
        this._freeSpinsInfo4.y = this._freeSpinsInfo3.y + this._freeSpinsInfo3.height + 25;
        this._features.push(this._freeSpinsInfo4);
        container.addChild(this._freeSpinsInfo4);

        this._rightContainer.addChild(this._freeSpinsInfo4);
        container.addChild(this._rightContainer);
        container.addChild(this._leftContainer);

        if (UserAgent.isMobile) {
            this.positionContainerItems();
        }
    }

    protected startPresentation(data?: ParsedServerData, onShowComplete?: () => void): void {
        super.startPresentation(data, onShowComplete);

        this.createGameText(this._gfxContainer);
    }

    private positionContainerItems(): void {
        this._leftContainer.getChildByName("_freeWinSpinsTitle").position.set(-550, -40);
        this._leftContainer.getChildByName("_starSpinTitle").position.set(-550, 180);
        this._rightContainer.getChildByName("_freeSpinsTitle").position.set(340, -20);

        this._leftContainer.getChildByName("_freeWinSpinsInfo1").position.set(-550, 20);
        this._leftContainer.getChildByName("_freeWinSpinsInfo2").position.set(-550, 100);
        this._leftContainer.getChildByName("_starSpinInfo").position.set(-550, 220);
        this._rightContainer.getChildByName("_freeSpinsInfo1").position.set(340, 20);
        this._rightContainer.getChildByName("_freeSpinsInfo2").position.set(340, 120);
        this._rightContainer.getChildByName("_freeSpinsInfo3").position.set(340, 200);
        this._rightContainer.getChildByName("_freeSpinsInfo4").position.set(340, 250);
    }
}
